import React, { useState, useEffect, useContext } from "react";
import FilterIcon from "components/Icons/FilterIcon";
import SearchIcon from "components/Icons/SearchIcon";
import FilterDropdown from "./FilterDropdown";
import DropIcon from "components/Icons/DropIcon";
import { DataGrid, GridActionsCellItem, GridToolbar } from "@mui/x-data-grid";
import SelectDropdown from "./SelectDropdown";
import { map, range } from "lodash";
import "./styles.css";
import CopyIcon from "components/Icons/CopyIcon";
import ChevronArrowLeftIcon from "components/Icons/ChevronArrowLeftIcon";
import ChevronArrowRightIcon from "components/Icons/ChevronArrowRightIcon";
import DeleteIcon from "components/Icons/DeleteIcon";
import ThreeVerticalDotsIcon from "components/Icons/ThreeVerticalDotsIcon";
import SimpleCard from "pages/dashboard/shared/SimpleCard";
import {
  Box,
  TablePagination,
  Typography,
  Stack,
  CircularProgress,
  Button,
  ClickAwayListener,
  Tooltip,
  styled
} from "@mui/material";
import NewCustomTable from "components/table/NewTable";
import { getAllRequestLog, getAllStat, processRequest } from "services/https/fetchers";
import { columns, dataKeysAndRepr, requestLogsSummaryCard } from "./data";
import useMenu from "hooks/useMenu";
import { ADMIN_USER_TABLE_MENU, USER_TABLE_MENU } from "utils/constant";
import useMatStyles from "./style";
import AntDropdown from "components/dialog/dropdown";
import { CSVLink } from "react-csv";
import { useDispatch } from "react-redux";
import { notifyFailure, notifySuccess } from "redux/actions/AlertActions";
import Loading from "components/shared/appLoader/AppLoader";
import AuthContext from "contexts/JWTAuthContext";
import { userHasPermission } from "utils/utilFn";
import { formatDate } from '../../../../utils/utilFn'
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { TextToLabel } from "utils/textToLabel";
import { useNavigate } from "react-router-dom";



const defaultFilters = {
  status: "",
};


const RequestLogs = () => {
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [err, setErrMsg] = useState("");
  const dispatch = useDispatch();
  // const [data, setData] = useState([]);
  const [data, setData] = useState({ content: [] });
  const [pageData, setPageData] = useState();
  const [stat, setStat] = useState([])
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchResult, setSearchResult] = useState('');
  const [searchText, setSearchText] = useState('');
  const [ status, setStatus] = useState('All');
  const [filterItem, setFilterItem] = useState('');
  const [loading, setLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [filters, setFilters] = useState(defaultFilters);
  const [open, setOpen] = useState(false);
  const styles = useMatStyles();
  const { userPermissions } = useContext(AuthContext);
  // const showManaging = userHasPermission(userPermissions, 'MANAGE_REQUEST')

  const StyledHeadSearch = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  }));

  const navigate = useNavigate();
  const destructureNeed = (data = []) => {
    const objArray = data.map((contentData) => {
      const {
        disputeType,
        disputeAmount,
        transactionDate,
        dateCreated,
        disputeStatus,
        merchantComplaintId,
        merchantEmail,
      } = contentData;
      return {
        disputeStatus: TextToLabel(disputeStatus),
        disputeType,
        disputeAmount: `NGN${disputeAmount ?? "N/A"} on ${
          transactionDate ?? "N/A"
        }`,
        dateCreated,
        merchantEmail,
        id: merchantComplaintId,
      };
    });
    setData({ content: objArray });
  };


  useEffect(() => {
    setIsLoading(true);
  
    getAllRequestLog({
      page,
      size: rowsPerPage,
      ...filters,
    })
      .then((res) => {
        setIsLoading(false);
        setPageData(res);
        destructureNeed(res?.content || []);
      })
      .catch(() => setIsLoading(false));
  }, [page, rowsPerPage, filters]);

  const handleChangePage = async (newPage) => {
    console.log(newPage);
    //setPagination({ ...pagination, current: newPage });
    setPage(newPage);
  };

  


  useEffect(() => {
    setLoading(true)
     getAllStat()
        .then((resp) => {
          const {  totalRequest, totalInitiated, totalApproved, totalRejected, totalFailed } = resp || {};
          setLoading(false)
          setStat({
              totalRequest,
              totalInitiated,
              totalApproved,
              totalRejected,
              totalFailed
          });
          
        })
        .catch((err) => {
          setLoading(false)
          console.log(err);
        });
    
  }, []);
  

  
  const actionOptions = ["Approve", "Reject", 'Delete']
  const handleAction = async(e, id)=>{
    setLoading(true)
    let postData ={
      action: e==='Approve'?'Approved': e==='Reject'?'Rejected': 'Delete' ,
      requestId: id
    }
     processRequest(postData)
      .then((res)=>{
        setLoading(false)
        if (res?.status) {
          dispatch(
            notifySuccess({ msg: res?.message })
          );
        } else {
          dispatch(
            notifyFailure({ msg: res?.message })
          );
          setErrMsg(res.message || "An error occured, please try again.");          
        }
      })
      .finally(() => {
        setLoading(false)
      });  
  
  }

  const handleRowClick = (id) => {
    console.log("checking id", id);
    navigate(`/logs/dispute/merchant/resolution/${id}`, {
      state: { details: true },
    });
  };
  
  const columns1 = React.useMemo(() => [
    {
      field: "requestId",
      headerName: "Request Id",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,

    },
    {
      field: "createdBy",
      headerName: "Requested By",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,

    },
    {
      field: "initiatorRole",
      headerName: "Role",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,
      renderCell: ({row})=> row?.initiatorRole?.replace(/_/g, ' ')

    },
    {
      field: "customerName",
      headerName: "Requested For",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,

    },
    {
      field: "requestType",
      headerName: "Request Type",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,

    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,
      renderCell: ({row})=> row?.status === 'Initiated'?'Pending':row?.status ==='Deleted'?'Failed':row?.status
    },
    {
      field: "dateCreated",
      headerName: "Date Created",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,
      renderCell: ({row})=> formatDate(row?.dateCreated)
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => (
        <AntDropdown
          dropDownOptions={actionOptions}
          handleDropdownAction={(item) => handleAction(item, row?.requestId)}
          userId={row}
          isArrow
        />
      ),

    }
  ])

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

    return (
    <>

<StyledHeadSearch>
      <Stack direction={"row"}>
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <div>
            <Tooltip
              PopperProps={{
                disablePortal: true,
              }}
              onClose={handleTooltipClose}
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
                // title={<FilterForm close={handleTooltipClose} />}
                title={
                  <FilterDropdown
                    values={filters}
                    onChange={setFilters}
                    onApply={() => setPage(0)}
                    onClear={() => setFilters(defaultFilters)}
                    close={handleTooltipClose}
                  />
                }
              arrow
            >
              <Button
                onClick={handleTooltipOpen}
                startIcon={<FilterAltIcon />}
                sx={{ mr: 4 }}
              >
                {"Filter"}
              </Button>
            </Tooltip>
          </div>
        </ClickAwayListener>
      </Stack>
      <Stack direction="row" spacing={2}>
        <Button variant="contained">
        <CSVLink data={data?.content || []} filename={"Request_Log.csv"}>
            {"Export"}
          </CSVLink>
        </Button>
      </Stack>
    </StyledHeadSearch>
    
    <Box
        sx={{
          mb: 3,
          overflowX: "auto",
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{
            minWidth: "600px",
            pb: 1
          }}
        >
          {requestLogsSummaryCard.map(({ title, objKeyRepr }) => (
            <Box key={`${objKeyRepr}`} sx={{ minWidth: 160 }}>
              <SimpleCard
                title={title}
                width="100%"
                height="120px"
              >
                <Typography variant="h6">
                  {(stat && stat[objKeyRepr]) ?? (
                    <CircularProgress size={12} />
                  )}
                </Typography>
              </SimpleCard>
            </Box>
          ))}
        </Stack>
      </Box>
      
      <div>
      <div  style={{ flexGrow: 1 }}>
      {loading ? (
        <Box sx={{ width: "100%", height: "40vh" }}>
          <Loading />
        </Box>
      ) :
      <div>
      {/* {data?.users?.length>0 && <DataGrid
            className={styles.table}     //requestType
            rows={(searchText)?data?.users?.filter(e=>e.requestId.toLowerCase().includes(searchText?.toLowerCase())||e.requestType.toLowerCase().includes(searchText?.toLowerCase())||e.status.toLowerCase().includes(searchText?.toLowerCase()))
            :data?.users}
            columns={columns1}
            page={page}
           pageSize={rowsPerPage}
            onPageSizeChange={(newPageSize) =>
              handleChangeRowsPerPage(newPageSize)
            }
            onPageChange={(newPage) => handleChangePage(newPage)}
            rowsPerPageOptions={[2, 10, 20, 50, 100]}
           // components={{ Toolbar: GridToolbar }}
            rowCount={data?.count}
          />} */}
      
                <NewCustomTable
        dataKeysAndRepr= {columns1}
        dataItemRows={data?.content}
        // pageData={data}
        pageData={pageData}
        alignAction={"center"}
        isLoading={isLoading}
        handleRowClick={handleRowClick}
      />

      <TablePagination
        component="div"
        // count={data.count || 0}
        count={pageData?.totalElements || 0}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
      />
              </div>}

      </div>
      </div>
    </>
  );
};

export default RequestLogs;
